import React, { useEffect, useState } from 'react';
import { KeyContainer } from '../../components/developers/KeyContainer';
import { RightSideContainer } from '../../components/developers/RightSideContainer';
import { BASE_URL } from '../../../config/environmentConfig';
import { useTranslation } from 'react-i18next';
import { CSVLinkComponent } from '../../components/developers/CSVLinkComponent';
import { fetchTokenizationKey } from '../../api/tokenization-api-service';
import { useParams } from 'react-router-dom';

export const TokenizationPage = (): JSX.Element => {
	const { id } = useParams<{ id: string }>();
	const [tokenizationKey, setTokenizationKey] = useState('');
	const [loading, setLoading] = useState(false);
	const { t } = useTranslation();

	const fetchData = async (): Promise<void> => {
		setLoading(true);
		const data = await fetchTokenizationKey(id);

		setTokenizationKey(data);

		setLoading(false);
	};

	useEffect(() => {
		void fetchData();
	},[]);

	const csvData = [
		[`${t('TOKENIZATION.ENDPOINT')}`, `${BASE_URL.TOKENIZATION_ENDPOINT}`],
		[`${t('TOKENIZATION.KEY')}`, `${tokenizationKey}`]
	];

	return (
		<div className="card mb-5">
			<div className="d-md-flex justify-content-md-between">
				<div className="card-body w-md-50">
					<KeyContainer
						value={BASE_URL.TOKENIZATION_ENDPOINT}
						title={t('TOKENIZATION.ENDPOINT')}
						loading={false}
						isTooltipShown
						canCopy
						copyWithText
						additionalCopyClass="ms-3"
					/>
					<KeyContainer
						value={tokenizationKey}
						title={t('TOKENIZATION.KEY')}
						loading={loading}
						isTooltipShown
						canCopy
						copyWithText
						additionalCopyClass="ms-3"
					/>

					{
						tokenizationKey && tokenizationKey !== '-' && (
							<CSVLinkComponent csvData={csvData} filename='tokenizationKey'/>
						)
					}
				</div>

				<div className="card-body w-md-50">
					<RightSideContainer
						title={t('TOKENIZATION.METHOD')}
						text={t('TOKENIZATION.DESCRIPTION')}
						linkText={t('TOKENIZATION.LEARN_MORE')}
						link={BASE_URL.TOKENIZATION_URL}
						isUnderLine
					/>
				</div>
			</div>
		</div>
	);
};
